<template>
  <div class="item-wrapper">
    <div class="item-title"><label class="font-title-label">{{ label }}</label></div>
    <div class="item-content"><label class="font-content-label"><slot></slot></label></div>
  </div>
</template>
<script>
export default {
  name: 'FormItemPrint',
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
  .item-wrapper {
    color: #000000;
    margin-bottom: 10px;
    line-height: 1;
    .font-title-label {
      font-size: 16px;
      font-weight: normal;
      display: inline-block;
      transform: scale(0.5) translateX(-50%);
    }
    .font-content-label {
      font-size: 22px;
      font-weight: normal;
      display: inline-block;
      margin-top: 6px;
      transform: scale(0.5) translateX(-50%);
      white-space: nowrap;
    }
  }
</style>
